import React from 'react';
import SectionLayout from 'atoms/Layout/Section/SectionLayout';
import Stack from 'atoms/Layout/Stack/Stack';
import HeroBannerTextBlock from 'organisms/Homepage/HeroBannerTextBlock/HeroBannerTextBlock';
import HeroBannerFilmStripWithEmail from 'organisms/Homepage/HeroBannerFilmStripWithEmail/HeroBannerFilmStripWithEmail';
import HeroBannerMetricsItems from 'organisms/Homepage/HeroBannerMetricsItems/HeroBannerMetricsItems';

const HeroBanner = (): JSX.Element => {
  return (
    <SectionLayout
      padding={['spacing-7xl', 'spacing-none']}
      paddingSm={['spacing-4xl', 'spacing-none']}
      maxWidth='width-3xl'
    >
      <Stack
        direction='column'
        gap='spacing-5xl'
        gapSm='spacing-4xl'
        dataCy='hero-text-block'
      >
        <HeroBannerTextBlock />
        <HeroBannerFilmStripWithEmail />
        <HeroBannerMetricsItems />
      </Stack>
    </SectionLayout>
  );
};

export default HeroBanner;
